import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    selectDoctorName,
    selectPacient,
    selectColor,
    selectPrice,
    selectPaid,
    selectTypePaid,
    selectTechnicId,
    setPacient,
    setColor,
    setPrice,
    setPaid,
    setTypePaid,
    selectOrder,
    setPhotos,
    setTechnicId,
} from "./orderSlice";
import moment from "moment";
import "./orderCard.css"; // для стилей
import { selectTechnics, setTechnics } from "../labSlice";
import { selectRole, selectUserId } from "../../Login/loginSlice";
import OrderPhotos from "./orderPhotos";
import { addPhotoOrder, getOrderPhotos, newTechnic, updateTechnic } from "./orderApi";
import OrderAudio from "./orderAudio";
import OrderComments from "./orderComments";
import TechnicModal from "./technicModal";
import { getTechnics } from "../labApi";

export default function OrderCard({ setIsChanged, dateDelivery, setDateDelivery }) {
    const dispatch = useDispatch();

    // из Redux
    const order = useSelector(selectOrder)
    const doctor_name = useSelector(selectDoctorName);
    const pacient = useSelector(selectPacient);
    const color = useSelector(selectColor);
    const price = useSelector(selectPrice);
    const paid = useSelector(selectPaid);
    const type_pay = useSelector(selectTypePaid);
    const technic_id = useSelector(selectTechnicId);
    const technics = useSelector(selectTechnics)
    const role = useSelector(selectRole)
    const user_id = useSelector(selectUserId)

    // локальное
    const [showDateDeliveryPicker, setShowDateDeliveryPicker] = useState(false);
    
    const [isUploading, setIsUploading] = useState(false);
    const [urlPhoto, setUrlPhoto] = useState('')
    const [showPhotoFullScreen, setShowPhotoFullScreen] = useState(false)
    const [initialPage, setInitialPage] = useState(0);
    const [showTechics, setShowTechics] = useState(false)
    const [showNewTechnicInput, setShowNewTechnicInput] = useState(false);

    const [newTechnicName, setNewTechnicName] = useState('');
    const [newTechnicSurname, setNewTechnicSurname] = useState('');
    const [comission, setComission] = useState(0);
    const [newTechnicCompany, setNewTechnicCompany] = useState('');
    const [IsNewTechnic, setIsNewTechnic] = useState(true);
    const [updateTechnicId, setUpdateTechnicId] = useState(0);

    const [updateTechnicUserId, setUpdateTechnicUserId] = useState(0);


    // хендлеры
    function handleChangePacient(e) {
        const text = e.target.value;
        const capitalized = text.charAt(0).toUpperCase() + text.slice(1);
        dispatch(setPacient(capitalized));
        setIsChanged(true);
    }

    function handleChangePrice(e) {
        const text = e.target.value;
        if (text.length === 0) {
            dispatch(setPrice(0));
            setIsChanged(true);
            return;
        }
        const nums = "0123456789";
        let text_price = "";
        let ind = 0;
        while (text[ind] === "0" && ind < text.length - 1) {
            ind++;
        }
        for (let i = ind; i < text.length; i++) {
            if (nums.indexOf(text[i]) > -1) {
                text_price = text_price + text[i];
            }
        }
        dispatch(setPrice(text_price));
    }

    function handleSetPaid(e) {
        const text = e.target.value;
        let text_paid = "";
        for (let i = 0; i < text.length; i++) {
            if (!isNaN(text[i])) text_paid = text_paid + text[i];
        }
        dispatch(setPaid(parseInt(text_paid || 0)));
        setIsChanged(true);
    }

    function handleEditTechnic(index) {
        // console.log('handleEditTechnic', technics[index].commission)
        setNewTechnicName(technics[index].name)
        setNewTechnicSurname(technics[index].surname)
        setComission(technics[index].commission)
        setShowNewTechnicInput(true)
        setIsNewTechnic(false)
        setUpdateTechnicId(technics[index].id)
        setUpdateTechnicUserId(technics[index].user_id)
    }



    function handleSelectTechnic(technic_id) {
        setShowTechics(false)
        dispatch(setTechnicId(technic_id))
    }

    function handleClickTechnic() {
        if (is_doctor) return;
        setShowTechics(true)
    }

    // const startCamera = () => {
    //     console.log('startCamera')
    //     // Веб: используем input type="file"
    //     const input = document.createElement("input");
    //     input.type = "file";
    //     input.accept = "image/*";
    //     input.onchange = async (e) => {
    //         const file = e.target.files[0];
    //         if (file) {
    //             await uploadPhoto(file);
    //         }
    //     };
    //     input.click();
    // };
    const startCamera = async () => {
        try {
            // Получаем доступ к камере
            const stream = await navigator.mediaDevices.getUserMedia({ video: true });

            // Создаём скрытое видео для захвата кадра
            const video = document.createElement("video");
            video.srcObject = stream;
            video.autoplay = true;

            // Ждём, пока видео подгрузится
            await new Promise(resolve => video.onloadedmetadata = resolve);

            // Снимаем кадр на canvas
            const canvas = document.createElement("canvas");
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(video, 0, 0);

            // Преобразуем кадр в Blob и отправляем
            canvas.toBlob(async (blob) => {
                if (blob) await uploadPhoto(blob);
                // Останавливаем камеру
                stream.getTracks().forEach(track => track.stop());
            }, "image/jpeg", 0.8);

        } catch (err) {
            console.error("Ошибка доступа к камере:", err);
            // fallback на input[type=file]
            fallbackToFileInput();
        }
    };

    // fallback input[type=file]
    const fallbackToFileInput = () => {
        const input = document.createElement("input");
        input.type = "file";
        input.accept = "image/*";
        input.onchange = async (e) => {
            const file = e.target.files[0];
            if (file) await uploadPhoto(file);
        };
        input.click();
    };


    // Вставка из буфера обмена
    const pasteImageFromClipboard = async () => {
        console.log('pasteImageFromClipboard')
        try {
            const clipboardItems = await navigator.clipboard.read();
            for (let item of clipboardItems) {
                if (item.types.includes("image/png") || item.types.includes("image/jpeg")) {
                    const blob = await item.getType(item.types[0]);
                    await uploadPhoto(blob);
                    return;
                }
            }
            alert("В буфере нет изображения");
        } catch (err) {
            console.error("Ошибка вставки из буфера:", err);
        }
    };

    // Общая функция загрузки фото
    const uploadPhoto = async (fileOrBlob) => {
        console.log('uploadPhoto', fileOrBlob)
        setIsUploading(true);
        // создаём FormData для отправки на сервер
        const formData = new FormData();
        formData.append("avatar", fileOrBlob);
        formData.append("order_id", order.id);

        addPhotoOrder(formData, () => {
            getOrderPhotos({ order_id: order.id }, (data) => {
                dispatch(setPhotos(data.photos));
                setIsUploading(false);
            });
        });
    };

    const pickImage = async () => {
        console.log('pickImage')
        try {
            const input = document.createElement("input");
            input.type = "file";
            input.accept = "image/*";
            input.onchange = async (e) => {
                const file = e.target.files[0];
                if (file) {
                    setIsUploading(true);
                    await uploadPhoto(file);
                }
            };
            input.click();
        } catch (error) {
            console.error("Ошибка при выборе изображения:", error);
            setIsUploading(false);
        }
    };

    // Просмотр фото fullscreen
    function handleShowPhotoFullScreen(url_photo, i) {
        setUrlPhoto(url_photo);
        setInitialPage(i);
        setShowPhotoFullScreen(true);
    }

    const handleSaveTechnic = () => {
        updateTechnic({
            comission: comission,
            name: newTechnicName,
            surname: newTechnicSurname,
            user_id: updateTechnicUserId
        }, (data) => {
            getTechnics({ user_id }, (res) => {
                console.log('getTechnics', res)
                dispatch(setTechnics(res.technics))
                setShowNewTechnicInput(false)
            })
        })
    }

    const handleClickCreateTechnic = () => {
        // console.log('newTechnicName', newTechnicName)
        if (newTechnicName.trim() === '') {      //|| newTechnicCompany === '') {
            alert('Заполните имя и клиника')
            return
        }
        newTechnic({
            name: newTechnicName,
            surname: newTechnicSurname,
            company: newTechnicCompany,
            user_id
        }, (data) => {
            getTechnics({ user_id }, (res) => {
                // console.log('getTechnics', res)
                dispatch(setTechnics(res.technics))
                setShowNewTechnicInput(false)
            })
        })
    }

    const onChangeDateDelivery = (event, selectedDate) => {
        console.log('onChangeDateDelivery triggered. selectedDate:', selectedDate);

        if (!selectedDate) {
            console.log('Дата не выбрана (отмена)');
            setShowDateDeliveryPicker(false);
            return;
        }

        const fixedDate = moment(selectedDate).tz('Europe/Moscow').startOf('day').toDate();

        console.log('Преобразованная дата:', fixedDate, '| typeof:', typeof fixedDate, '| instanceof Date:', fixedDate instanceof Date);

        setShowDateDeliveryPicker(false);
        setDateDelivery(fixedDate);
    };

    const is_doctor = role === 'doctor'

    return (
        <div className="order-card-container">
            <TechnicModal
                showTechics={showTechics}
                setShowTechics={setShowTechics}
                showNewTechnicInput={showNewTechnicInput}
                IsNewTechnic={IsNewTechnic}
                newTechnicName={newTechnicName}
                setNewTechnicName={setNewTechnicName}
                newTechnicSurname={newTechnicSurname}
                setNewTechnicSurname={setNewTechnicSurname}
                comission={comission}
                handleChangeComission={(e) => setComission(e.value)}
                handleClickCreateTechnic={handleClickCreateTechnic}
                handleSaveTechnic={handleSaveTechnic}
                handleDeleteTechnic={() => {/* твоя логика */ }}
                handleClickNewTechnic={() => setShowNewTechnicInput(true)}
                handleClose={() => setShowTechics(false)}
                handleClickCloseNewTechnic={() => setShowNewTechnicInput(false)}
                handleSelectTechnic={handleSelectTechnic}
                handleEditTechnic={handleEditTechnic}
                technics={technics}
            />

            {/* Доктор и Пациент */}
            <div className="row">
                <div className="col-48">
                    <label className="order-label">Доктор</label>
                    <div className="order-card-field">{doctor_name}</div>
                </div>
                <div className="col-48">
                    <label className="order-label">Пациент</label>
                    <input
                        className="order-card-input"
                        value={pacient}
                        onChange={handleChangePacient}
                        disabled={is_doctor}
                    />
                </div>
            </div>

            {/* Дата сдачи, Цвет, Техник */}
            <div className="row">
                {/* <div className="col-31">
                    <label className="order-label">Дата сдачи</label>
                    <div
                        className="order-card-field clickable"
                        onClick={() => !is_doctor && setShowDateDeliveryPicker(!showDateDeliveryPicker)}
                    >
                        {dateDelivery ? moment(dateDelivery).format("DD.MM.YYYY") : ""}
                    </div>
                </div> */}
                <div className="col-31">
                    <label className="order-label">Дата сдачи</label>
                    <input
                        type="date"
                        className="order-card-input"
                        value={dateDelivery ? new Date(dateDelivery).toISOString().split("T")[0] : ""}
                        onChange={(e) => {
                            setDateDelivery(e.target.value)
                            setIsChanged(true);
                        }}
                        disabled={is_doctor}
                    />
                </div>


                <div className="col-31">
                    <label className="order-label">Цвет</label>
                    <input
                        className="order-card-input"
                        value={color}
                        onChange={(e) => {
                            const text = e.target.value;
                            const capitalized = text.charAt(0).toUpperCase() + text.slice(1);
                            dispatch(setColor(capitalized));
                        }}
                        placeholder="Цвет"
                        disabled={is_doctor}
                    />
                </div>

                <div className="col-31">
                    <label className="order-label">Техник</label>
                    <div className="order-card-field clickable" onClick={handleClickTechnic}>
                        {technics.find((e) => e?.id === technic_id)?.name}{" "}
                        {technics.find((e) => e?.id === technic_id)?.surname}
                    </div>
                </div>
            </div>

            {/* Стоимость, Оплата, Метод оплаты */}
            <div className="row">
                <div className="col-30">
                    <label className="order-label">Стоимость</label>
                    <input
                        className="order-card-input"
                        value={price?.toString()}
                        onChange={handleChangePrice}
                        disabled={is_doctor}
                    />
                </div>

                <div className="col-30">
                    <label className="order-label">Оплачено</label>
                    <input
                        className="order-card-input"
                        style={{ color: price - paid > 0 ? "red" : "green" }}
                        value={paid?.toString()}
                        onChange={handleSetPaid}
                        disabled={is_doctor}
                    />
                </div>

                <div className="col-31">
                    <label className="order-label">Метод оплаты</label>
                    <div
                        className="order-card-field clickable"
                        onClick={() => {
                            if (is_doctor) return;
                            dispatch(setTypePaid(type_pay === "non-cash" ? "cash" : "non-cash"));
                        }}
                    >
                        {type_pay === "cash" ? "Наличные" : "Безнал"}
                    </div>
                </div>
            </div>

            <OrderPhotos
                role={role}
                startCamera={startCamera}
                pasteImageFromClipboard={pasteImageFromClipboard}
                pickImage={pickImage}
                isUploading={isUploading}
                handleShowPhotoFullScreen={handleShowPhotoFullScreen}
            />
            <OrderAudio />
            <OrderComments />

        </div>
    );
}
